module.exports = __webpack_public_path__ + "static/media/719DalvigneyStNW_2018-06-25_185.6c85a472.jpg";